import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class MissingReleasesWarning extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}


	render (){
		const {user: {primary_silo_code}} = this.props.user;
		const showWarning = primary_silo_code == 'eon';
		if(showWarning){
			return <div className="missing-data-warning-holder">
				<div className="missing-data-warning">
					<strong>Note: </strong>
					YouTube numbers after 03-31-2025 are no longer updating as MNRK transitions to a new delivery system.
				</div>
			</div>
		}
		return null;            
	}
}

function mapStateToProps(state) {
	return {
		user: state.user
	} 
}

export default connect(mapStateToProps)(MissingReleasesWarning)